<!-- Staff Details Dialog -->
<div class="admin-dialog admin-dialog--panel" [class.admin-dialog--display-mode]="mode === Mode.disp">
  <!-- Header -->
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <div class="admin-dialog__header-row">
        <div class="admin-dialog__avatar" [style.background-color]="'var(--gokuri-primary)'">
          {{ userFormGroup.get('lastName')?.value?.charAt(0) || '?' }}
        </div>
        <div class="admin-dialog__user-info">
          <span class="admin-dialog__title">{{ userFormGroup.get('lastName')?.value }} {{ userFormGroup.get('firstName')?.value }}</span>
          <span class="admin-dialog__subtitle">{{ userTypeDisp }}</span>
        </div>
      </div>
      <div class="admin-dialog__mode-badge" [class.admin-dialog__mode-badge--edit]="mode === Mode.edit || mode === Mode.create || mode === Mode.invite">
        @if (mode === Mode.disp) {
          <span i18n="@@adminSection.staffDetails.modeBadge.display">表示モード</span>
        } @else if (mode === Mode.edit) {
          <span i18n="@@adminSection.staffDetails.modeBadge.edit">編集モード</span>
        } @else if (mode === Mode.create) {
          <span i18n="@@adminSection.staffDetails.modeBadge.create">新規作成</span>
        } @else {
          <span i18n="@@adminSection.staffDetails.modeBadge.invite">招待</span>
        }
      </div>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onNoClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="admin-dialog__content">
    @if (isLoading()) {
      <!-- Skeleton Loading -->
      <div class="skeleton-form">
        <div class="skeleton-row">
          <div class="skeleton skeleton--field"></div>
          <div class="skeleton skeleton--field"></div>
        </div>
        <div class="skeleton skeleton--field-single"></div>
        <div class="skeleton-section">
          <div class="skeleton skeleton--label"></div>
          <div class="skeleton skeleton--checkbox"></div>
          <div class="skeleton skeleton--checkbox"></div>
        </div>
        <div class="skeleton skeleton--info-box"></div>
      </div>
    } @else if (mode === Mode.disp) {
      <!-- Display Mode: Simple Row Layout (design.pen Node: 9b1sv) -->
      <div class="staff-info-rows">
        <!-- Job Title Row -->
        <div class="staff-info-row">
          <mat-icon class="staff-info-row__icon">work</mat-icon>
          <span class="staff-info-row__label" i18n="@@adminSection.staffDetails.label.jobTitle">職種</span>
          <span class="staff-info-row__badge">
            @for (jobTitle of common.staffJobTitles; track jobTitle.code) {
              @if (jobTitle.code === staffData.jobTitleCode) {
                {{ jobTitle.desc }}
              }
            }
          </span>
        </div>

        <!-- Roles Row -->
        <div class="staff-info-row staff-info-row--vertical">
          <mat-icon class="staff-info-row__icon">shield</mat-icon>
          <span class="staff-info-row__label" i18n="@@adminSection.staffDetails.label.authority">権限</span>
          <div class="staff-info-row__roles">
            @for (role of common.staffRoles; track role.code) {
              @if (staffData.role?.includes(role.code)) {
                <div class="staff-role-item">
                  <mat-icon>check</mat-icon>
                  <span>{{ role.desc }}</span>
                </div>
              }
            }
            @if (!staffData.role?.length) {
              <span class="staff-info-row__no-role" i18n="@@adminSection.staffDetails.label.noRoles">権限なし</span>
            }
          </div>
        </div>

        <!-- Divider -->
        <div class="staff-info-divider"></div>

        <!-- Readonly Section -->
        <div class="admin-dialog__readonly-section">
          <h5 class="admin-dialog__readonly-title" i18n="@@adminSection.staffDetails.section.accountInfo">アカウント情報</h5>

          <div class="admin-dialog__readonly-row">
            <span class="admin-dialog__readonly-label" i18n="@@adminSection.staffDetails.label.accountId">アカウントID</span>
            <span class="admin-dialog__readonly-value">{{ staffData.userId }}</span>
          </div>

          <div class="admin-dialog__readonly-row">
            <span class="admin-dialog__readonly-label" i18n="@@adminSection.staffDetails.label.contractStartDate">利用開始日</span>
            <span class="admin-dialog__readonly-value">{{ staffData.contractStartAt }}</span>
          </div>

          <div class="admin-dialog__readonly-row">
            <span class="admin-dialog__readonly-label" i18n="@@adminSection.staffDetails.label.lastModified">最終更新</span>
            <span class="admin-dialog__readonly-value">{{ staffData.lastModifiedAt | date:'yyyy/MM/dd' }}</span>
          </div>
        </div>
      </div>
    } @else {
      <!-- Edit/Create/Invite Mode: Form with mat-form-field -->
      <form [formGroup]="userFormGroup" class="admin-dialog__form">
        <!-- Name Fields (Edit/Create modes) -->
        @if (mode === Mode.edit || mode === Mode.create) {
          <div class="admin-dialog__field-row">
            <mat-form-field appearance="outline" class="admin-dialog__field">
              <mat-label i18n="@@adminSection.staffDetails.label.lastName">姓</mat-label>
              <input matInput formControlName="lastName" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="admin-dialog__field">
              <mat-label i18n="@@adminSection.staffDetails.label.firstName">名</mat-label>
              <input matInput formControlName="firstName" />
            </mat-form-field>
          </div>
        }

        <!-- Email Field (Invite/Create modes) -->
        @if (mode === Mode.invite || mode === Mode.create) {
          <div class="admin-dialog__field-group">
            <mat-form-field appearance="outline" class="admin-dialog__field admin-dialog__field--wide">
              <mat-label i18n="@@adminSection.staffDetails.label.email">メールアドレス</mat-label>
              <mat-icon matSuffix class="material-icons-outlined">mail</mat-icon>
              <input matInput type="email" formControlName="email" />
              <mat-hint i18n="@@adminSection.staffDetails.hint.email">招待メールが送信されます</mat-hint>
              @if (userFormGroup.get('email')?.hasError('required')) {
                <mat-error i18n="@@adminSection.staffDetails.error.emailRequired">メールアドレスは必須です</mat-error>
              } @else if (userFormGroup.get('email')?.hasError('email')) {
                <mat-error i18n="@@adminSection.staffDetails.error.emailInvalid">有効なメールアドレスを入力してください</mat-error>
              }
            </mat-form-field>
          </div>
        }

        <!-- Job Title Field -->
        <div class="admin-dialog__field-group">
          <mat-form-field appearance="outline" class="admin-dialog__field">
            <mat-label i18n="@@adminSection.staffDetails.label.jobTitle">職種</mat-label>
            <mat-icon matSuffix class="material-icons-outlined">work</mat-icon>
            <mat-select formControlName="jobTitleCode">
              @for (jobTitle of common.staffJobTitles; track jobTitle.code) {
                <mat-option [value]="jobTitle.code">{{ jobTitle.desc }}</mat-option>
              }
            </mat-select>
            <mat-hint i18n="@@adminSection.staffDetails.hint.jobTitle">スタッフの職種を選択</mat-hint>
          </mat-form-field>
        </div>

        <!-- Roles Section -->
        <div class="admin-dialog__section">
          <h4 class="admin-dialog__section-title" i18n="@@adminSection.staffDetails.label.authority">権限</h4>
          <div class="role-checkboxes">
            @for (role of common.staffRoles; track role.code) {
              <label class="role-checkbox">
                <mat-checkbox [formControlName]="role.code" color="primary">
                </mat-checkbox>
                <div class="role-checkbox__content">
                  <span class="role-checkbox__label">{{ role.desc }}</span>
                </div>
              </label>
            }
          </div>
        </div>

        <!-- Readonly Info (Edit mode only) -->
        @if (mode === Mode.edit) {
          <div class="admin-dialog__readonly-section">
            <h5 class="admin-dialog__readonly-title" i18n="@@adminSection.staffDetails.section.systemInfo">システム情報</h5>

            <div class="admin-dialog__readonly-row">
              <span class="admin-dialog__readonly-label" i18n="@@adminSection.staffDetails.label.accountIdEdit">アカウントID</span>
              <span class="admin-dialog__readonly-value">{{ userFormGroup.get('userId')?.value }}</span>
            </div>

            <div class="admin-dialog__readonly-row">
              <span class="admin-dialog__readonly-label" i18n="@@adminSection.staffDetails.label.contractStart">契約開始日</span>
              <span class="admin-dialog__readonly-value">{{ userFormGroup.get('contractStartAt')?.value }}</span>
            </div>

            @if (userFormGroup.get('contractEndAt')?.value) {
              <div class="admin-dialog__readonly-row">
                <span class="admin-dialog__readonly-label" i18n="@@adminSection.staffDetails.label.contractEnd">契約終了日</span>
                <span class="admin-dialog__readonly-value">{{ userFormGroup.get('contractEndAt')?.value }}</span>
              </div>
            }
          </div>
        }
      </form>
    }
  </div>

  <!-- Footer -->
  <div class="admin-dialog__footer">
    @if (mode === Mode.disp) {
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@adminSection.staffDetails.button.close">閉じる</span>
      </button>
    } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@adminSection.staffDetails.button.discard">破棄</span>
      </button>
    }
    <button mat-flat-button color="primary" [disabled]="isSending()" (click)="onEditOrUploadClicked()">
      @if (isSending()) {
        <mat-spinner diameter="18"></mat-spinner>
      }
      @if (mode === Mode.disp) {
        <span i18n="@@adminSection.staffDetails.button.edit">編集</span>
      } @else if (mode === Mode.edit) {
        <span i18n="@@adminSection.staffDetails.button.save">保存</span>
      } @else if (mode === Mode.invite) {
        <span i18n="@@adminSection.staffDetails.button.invite">招待</span>
      } @else {
        <span i18n="@@adminSection.staffDetails.button.create">作成</span>
      }
    </button>
  </div>
</div>
